import { ReactNode } from 'react'

import { cn } from '@lib/cn'

export const Card = ({ className, ...props }: React.ComponentProps<'div'>) => (
  <div className={cn('flex flex-col rounded-2xl border border-o-line bg-o-card shadow-o-card', className)} {...props} />
)

export const CardHeader = ({
  title,
  description,
  action,
  className
}: {
  title: ReactNode
  description?: ReactNode
  action?: ReactNode
  className?: string
}) => (
  <div className={cn('flex items-center justify-between gap-4 border-b border-o-hair px-4 py-[15px] md:px-5 md:py-4', className)}>
    <div className="flex min-w-0 flex-col gap-0.5">
      <span className="text-[15px] font-medium text-o-ink">{title}</span>
      {description && <span className="text-[13px] text-o-muted">{description}</span>}
    </div>
    {action && <div className="shrink-0 text-[13px] text-o-slate">{action}</div>}
  </div>
)

export const DetailList = ({ className, ...props }: React.ComponentProps<'div'>) => (
  <div
    className={cn('flex flex-col rounded-2xl border border-o-line bg-o-card px-4 py-1 text-[13.5px] shadow-o-card md:px-[22px] md:py-1.5', className)}
    {...props}
  />
)

export const DetailRow = ({
  label,
  children,
  action,
  mono,
  className
}: {
  label: ReactNode
  children: ReactNode
  action?: ReactNode
  mono?: boolean
  className?: string
}) => (
  <div className={cn('flex items-end gap-3 border-b border-o-hair py-3 last:border-b-0 md:items-center', className)}>
    <span className="flex min-w-0 flex-1 flex-col gap-1 md:flex-row md:items-center md:gap-3">
      <span className="text-[12.5px] leading-4 text-o-muted md:w-[140px] md:shrink-0 md:text-[13.5px] md:leading-normal">{label}</span>
      <span className={cn('min-w-0 leading-[18px] text-o-ink [overflow-wrap:anywhere] md:flex-1 md:truncate md:leading-normal', mono && 'font-mono text-[12.5px] md:text-[13px]')}>
        {children}
      </span>
    </span>
    {action && <span className="shrink-0 text-[12.5px] leading-[18px] text-o-slate md:leading-normal">{action}</span>}
  </div>
)

export const StatusDot = ({ tone, className }: { tone: 'live' | 'pending' | 'failed' | 'idle' | 'ink'; className?: string }) => (
  <span
    className={cn(
      'inline-block size-1.5 shrink-0 rounded-full',
      tone === 'live' && 'bg-o-mint',
      tone === 'pending' && 'bg-o-amber',
      tone === 'failed' && 'bg-o-red',
      tone === 'idle' && 'bg-o-faint',
      tone === 'ink' && 'bg-o-ink',
      className
    )}
  />
)
